<mat-grid-list [cols]="cols" [rowHeight]="rowHeight" [gutterSize]="gutterSize">
  <mat-grid-tile
    *ngFor="let item of gridItems; trackBy: trackByFn"
    [colspan]="item.colspan"
    [rowspan]="item.rowspan"
  >
    <ng-container *ngTemplateOutlet="item.templateRef"> </ng-container>
  </mat-grid-tile>
</mat-grid-list>
